export function GetMockMilestoneList() {
  return [
    {
      id: 1,
      milestoneTypeId: 18,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-05-12T10:32:22.0598484",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"qualificationStatus":1,"qualifiedDate":"2022-02-01T00:00:00.000Z","caseProceedable":0,"caseProceedableYesWhy":"Proceeding with JMNB","sharedOwnershipPurchase":0,"isHTB":0,"standardPurchase":1,"qualifiedReserve":0,"isMilestoneComplete":1,"caseProceedableNoWhy":"Proceeding via own means"}',
      sendEmail: 1,
      updateCaseStatus: 1,
      offerExpiryDate: "0001-01-01T00:00:00",
    },
    {
      id: 2,
      milestoneTypeId: 19,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-03-04T14:29:41.2166139",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"dateCompleted":"2022-02-09T00:00:00.000Z","isMilestoneComplete":1}',
      sendEmail: 1,
      updateCaseStatus: 0,
      offerExpiryDate: "0001-01-01T00:00:00",
    },
    {
      id: 3,
      milestoneTypeId: 20,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-04-19T15:19:37.199609",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"expectedBuildComplete":"2022-02-09T00:00:00.000Z","dateReserved":"2022-02-01T00:00:00.000Z","isMilestoneComplete":1}',
      sendEmail: 0,
      updateCaseStatus: 0,
      offerExpiryDate: "0001-01-01T00:00:00",
    },
    {
      id: 4,
      milestoneTypeId: 21,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-05-12T10:34:30.6470097",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"dateCompleted":"2022-02-01T00:00:00.000Z","lenderNotes":"Test","isMilestoneComplete":1}',
      sendEmail: 1,
      updateCaseStatus: 0,
      offerExpiryDate: "0001-01-01T00:00:00",
    },
    {
      id: 5,
      milestoneTypeId: 22,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-06-21T15:20:53.3440472",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"valuationDate":"2022-02-01T00:00:00.000Z","dateInstructed":"2022-02-01T00:00:00.000Z","isMilestoneComplete":1,"surveyorDetails":"Mr surveyor","surveyorContact":"01206 555458"}',
      sendEmail: 0,
      updateCaseStatus: 1,
      offerExpiryDate: "0001-01-01T00:00:00",
    },
    {
      id: 6,
      milestoneTypeId: 23,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-05-12T10:32:48.6716148",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"dateCompleted":"2022-02-01T00:00:00.000Z","isMilestoneComplete":0}',
      sendEmail: 0,
      updateCaseStatus: 0,
      offerExpiryDate: "0001-01-01T00:00:00",
    },
    {
      id: 7,
      milestoneTypeId: 24,
      caseId: 1,
      updatedByUserId: 4,
      dateUpdated: "2022-05-12T10:34:19.9844303",
      milestoneDate: "0001-01-01T00:00:00",
      milestoneData:
        '{"offerExpiryDate":"2022-02-01T00:00:00.000Z","isMilestoneComplete":1}',
      sendEmail: 0,
      updateCaseStatus: 0,
      offerExpiryDate: "2022-02-01T00:00:00",
    },
  ];
}
